import restGql from 'graphql-tag';

export const CreateProduct = restGql`#graphql
    mutation CreateProduct(
        $input: CreateProductMutationVariables!
    ) {
        createProduct(input: $input) @rest(
            type: "CreateProduct", 
            method: "POST",
            path: "/v2/products",
            bodyKey: "input"
        ) {
            product {
                id
                availabilityIdsByDays
                title
                discountable
                pricing {
                    adhocPrice
                    pricingGroupId
                    price
                    pricing
                    period
                    volume
                }
                hiddenByUser
            }
        }
    }`;
